// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__SkipNav__skipNav{background-color:var(--JDS-COLOR-BACKGROUND-PAGE,#f8f9fa);left:6px;position:absolute;top:6px;z-index:400}.jut__SkipNav__skipNav:not(:focus){height:0;overflow:hidden;width:0}", "",{"version":3,"sources":["webpack://./../src/SkipNav.module.scss","webpack://./../../platform/@jutro/app/SkipNav.module.css"],"names":[],"mappings":"AAEA,uBAKE,yDAAA,CAFA,QAAA,CAFA,iBAAA,CACA,OAAA,CAEA,WCAF,CDIA,mCAEE,QAAA,CACA,eAAA,CAFA,OCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skipNav": "jut__SkipNav__skipNav"
};
export default ___CSS_LOADER_EXPORT___;
